import {DiscountModel, ProductModel} from "../Models/ProductModel";
import {OrderProductModel} from "../Models/OrderModel";
import {useGetTva} from "./useGetTva";
import {useGetReductionFromPercentage} from "./useGetReductionFromPercentage";

export const useCreateOrderWithPercentDiscount = (): (p: ProductModel, discount: DiscountModel, quantitee: number) => OrderProductModel => {
    const getTva = useGetTva()
    const [getTotalMinusReduction, getReduction] = useGetReductionFromPercentage()

    const createOrder = (p: ProductModel, discount: DiscountModel, quantitee: number): OrderProductModel => {
        const rate = discount.discount.rate
        const unitTva = getTva(p.priceTTC, p.product.tva?.rate)
        const unitPriceHT = p.priceTTC - unitTva
        return {
            name: p.product.name,
            privateName: p.product.privateName,
            nameCategory: p.product.productCategories[0]?.name,
            nameFamily: p.product.productCategories[0]?.productCategoryFamily?.name,
            quantity: quantitee,
            unitPriceHT: unitPriceHT,
            unitPriceTTC: p.priceTTC,
            unitDepositPriceTTC: p.depositPriceTTC,
            tvaRate: p.product.tva?.rate,
            discount: getReduction(p.priceTTC * quantitee, rate),
            discountName: discount.name,
            discountType: 'percent',
            discountRate: rate,
            totalPriceHT: +(getTotalMinusReduction(unitPriceHT * quantitee, rate).toFixed(5)),
            totalPriceTTC: +(getTotalMinusReduction(p.priceTTC * quantitee, rate)).toFixed(2),
            totalDepositPriceTTC: p.depositPriceTTC * quantitee,
            totalTva: +(getTotalMinusReduction(unitTva * quantitee, rate)).toFixed(2),
            tvaCode: p.product.tva?.id,
            product: {
                id: p.product.id,
                image: p.product.image,
                categories: p.product.productCategories
            }
        }
    }

    return (p: ProductModel, discount: DiscountModel, quantitee: number): OrderProductModel => {
        const result = createOrder(p, discount, quantitee)

        if (p.product.isMenu && p.eventPdvProducts?.length > 0) {
            result.eventPdvProducts = p.eventPdvProducts.map(extra => {
                const extraAsProduct: ProductModel = {
                    priceTTC: extra.priceTTC ?? 0,
                    depositPriceTTC: 0,
                    product: extra.product,
                    automaticDiscounts: [],
                    stockAvailable: 0,
                    eventPdvProducts: []
                }
                const orderProduct = createOrder(extraAsProduct, discount, quantitee)
                orderProduct.productMenuName = p.product.name
                return orderProduct
            })
            const avgTvaRate = result.eventPdvProducts.reduce((sum, e) => sum + (e.tvaRate ?? 0), 0) / result.eventPdvProducts.length
            result.tvaRate = Math.round(avgTvaRate * 100) / 100
        }

        return result
    }
}
